import { motion } from "framer-motion";
import { Reveal, SectionTitle } from "./Reveal";
import { IMAGES } from "@/data/site";

export const About = () => (
  <section id="hakkimizda" className="relative py-28 lg:py-36 bg-white overflow-hidden" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-5 relative order-2 lg:order-1">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-6 rounded-[3rem] bg-grad-blush" />
            <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.6 }} className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_70px_-30px_rgba(139,0,79,0.4)] aspect-[4/5]">
              <img src={IMAGES.about} alt="Diva Nail Beauty Esenyurt güzellik salonu – salon içi" className="w-full h-full object-cover" loading="lazy" data-testid="about-image" />
            </motion.div>
            <div className="absolute -bottom-6 -right-4 sm:-right-8 bg-grad-dark text-white rounded-3xl p-6 shadow-xl max-w-[220px]">
              <p className="text-3xl font-bold text-gradient-light">Esenyurt</p>
              <p className="text-sm text-pink-100/80 mt-1">İstanbul'un kalbinde premium bakım</p>
            </div>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7 order-1 lg:order-2 lg:pl-8">
        <SectionTitle eyebrow="Hakkımızda" title={<>Şıklık, hijyen ve <span className="text-gradient">profesyonellik</span> bir arada</>} />
        <Reveal delay={0.25}>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-zinc-600 max-w-2xl">
            Diva Nail Beauty, Esenyurt / İstanbul'da hizmet veren, bakım ve güzellik alanında şıklığı, hijyeni ve profesyonelliği bir araya getiren özel bir güzellik salonudur. Her müşterimize özenli, kaliteli ve memnuniyet odaklı hizmet sunuyoruz.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {[["Protez Tırnak", "Kalıcı ve estetik"], ["İpek Kirpik", "Doğal hacim"], ["Cilt Bakımı", "Işıltılı cilt"]].map(([t, d]) => (
              <div key={t} className="card-soft rounded-2xl p-5 hover:-translate-y-1 transition-transform duration-300">
                <div className="w-10 h-1 rounded-full bg-grad-pink mb-4" />
                <p className="font-semibold text-[#1a1118]">{t}</p>
                <p className="text-sm text-zinc-500 mt-1">{d}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
